import React from "react";

//创建并export上下文
export const AppContext = React.createContext(null);

